/**
 * Created by jv on 18/01/2017.
 */
const utils = require("Sources/utils/utils");
const moment = require("moment");
const LanguageManager = require("Sources/services/languagemanager");
const Contact = require("Sources/models/contact");
const Article = require("Sources/models/article");
const Invoice = require("Sources/models/invoice");
const Customer = require("Sources/models/admin/customer");

module.exports = class Order
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.number = options.number || options["order-number"];

    this.profileKey = options["profile-key"];

    this.type = options.type || options["order-type"];
    this.status = options.status || options["order-status"];
    this.onHold = options["on-hold"];
    this.groupPurchaseKey = options["group-purchase-key"];

    this.editable = options["can-be-edited"];
    this.cancellable = options["can-be-cancelled"];

    this.invoice = options.invoice;

    this.contacts = utils.isArray(options.contacts) ? options.contacts : [];

    this.articles = utils.isArray(options["order-articles"]) ? options["order-articles"] : [];

    this.totalPrice = options["total-price"];
    this.payReference = options["pay-reference"];
    this.purchaseOrderNumber = options["bestelbon-number"];
    this.vat = options.vat;
    this.companyNumber = options["company-number"];

    this.purchaseOrderRequired = options["bestelbon-required"];

    this.paymentOk = options["payment-ok"];
    this.cancelled = options.cancelled;
    this.remark = options.remark;

    this.comment = options.comment;

    this.created = options.created || options["order-created"];

    if(utils.isDefined(options.customer))
    {
      this.customer = options.customer;
    }

    // Work around for order summary JSON sturcture (manually add a contact with key 'CON')
    if(utils.isDefined(options["person-firstname"]) && utils.isDefined(options["person-lastname"]) && utils.isDefined(options["organisation-name"]) && utils.isDefined(options["organisation-city"]))
    {
      this.addContact({
        person: {
          firstname: utils.isNotNull(options["person-firstname"]) ? options["person-firstname"] : "",
          lastname: utils.isNotNull(options["person-lastname"]) ? options["person-lastname"] : ""
        },
        organisation: {
          name: options["organisation-name"],
          city: options["organisation-city"]
        },
        type: "CON"
      });
    }
  }

  get isGroupPurchase()
  {
    return utils.isNotNull(this.groupPurchaseKey) ? "globals.options.yes" : "globals.options.no";
  }

  set customer(customer)
  {
    this._customer = new Customer(customer);
  }

  get customer()
  {
    return this._customer;
  }

  get customerKey()
  {
    return utils.isNotNull(this.customer) ? this.customer.key : null;
  }

  set created(date)
  {
    this._created = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get created()
  {
    return utils.isMomentObject(this._created) ? this._created.format("DD-MM-YYYY") : null;
  }

  set contacts(contacts)
  {
    this._contacts = [];

    if(utils.isArray(contacts))
    {
      for(var i = 0; i < contacts.length; i++)
      {
        this._contacts.push(new Contact(contacts[i]));
      }
    }
  }

  addContact(options)
  {
    this.contacts.push(new Contact(options))
  }

  get contacts()
  {
    return this._contacts;
  }

  getContactForType(type)
  {
    for(var i = 0; i < this.contacts.length; i++)
    {
      if(this.contacts[i].type === type)
      {
        return this.contacts[i];
      }
    }

    return null;
  }

  get contactFullname()
  {
    var contactPerson = this.getContactForType("CON");

    if(utils.isNotNull(contactPerson))
    {
      return contactPerson.person.firstname + " " + contactPerson.person.lastname;
    }

    return null;
  }

  get organisation()
  {
    var contactPerson = this.getContactForType("CON");

    return utils.isNotNull(contactPerson) ? contactPerson.organisation.name : null;
  }

  get city()
  {
    var contactPerson = this.getContactForType("CON");

    return utils.isNotNull(contactPerson) ? contactPerson.organisation.city : null;
  }

  set invoice(invoice)
  {
    this._invoice = new Invoice(invoice);
  }

  get invoice()
  {
    return this._invoice;
  }

  set articles(articles)
  {
    this._articles = [];

    if(utils.isArray(articles))
    {
      for(var i = 0; i < articles.length; i++)
      {
        this._articles.push(new Article(articles[i]));
      }
    }
  }

  get articles()
  {
    return this._articles;
  }

  get readableStatus()
  {
    switch(this.status)
    {
      case "payed":
      case "complete":
        return "subscription_details.payment_status.payed";
      case "awaiting_approval":
      case "awaiting_invoice":
        return "subscription_details.payment_status.processing";
      case "awaiting_payment":
        return "subscription_details.payment_status.processing_payment";
      case "awaiting_delivery":
        return "subscription_details.payment_status.processing_delivery";
      case "cancelled":
      case "awaiting_cancellation":
        return "subscription_details.payment_status.cancelled";
      default:
        return this.status;
    }
  }

  get readableVatNumber()
  {
    return utils.isNullOrEmpty(this.vat) ? "-" : this.vat;
  }

  get readableCompanyNumber()
  {
    return utils.isNullOrEmpty(this.companyNumber) ? "-" : this.companyNumber;
  }

  get readablePurchaseOrderRequired()
  {
    return this.purchaseOrderRequired ? "globals.options.yes" : "globals.options.no";
  }

  get readablePurchaseOrderNumber()
  {
    return utils.isNull(this.purchaseOrderNumber) ? "-" : this.purchaseOrderNumber;
  }

  get readablePayReference()
  {
    return utils.isNull(this.payReference) ? "-" : this.payReference;
  }

  get undeliveredArticles()
  {
    var undeliveredArticles = [];

    for(var i = 0; i < this.articles.length; i++)
    {
      if(this.articles[i].physicalDelivery === true && utils.isNull(this.articles[i].delivered))
      {
        undeliveredArticles.push(this.articles[i]);
      }
    }

    return undeliveredArticles;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/order.js